<template>
  <!-- <div><img :src="apiData.imageURL" alt="banner" /></div> -->
  <div>
    <img v-if="bannerUrl" :src="bannerUrl" alt="banner" />
    <BannerSlider v-else />
    <!-- <img v-else src="../../img/Banner.png" alt="banner" /> -->
  </div>
</template>

<script>
import { ref, watch } from "vue";
import { useRoute } from "vue-router";
import { apiCountries } from "@/api/api.js";
import BannerSlider from "@/components/Home/BannerSlider.vue";

export default {
  components: {
    BannerSlider,
  },
  name: "Banner",
  setup() {
    const route = useRoute();
    const bannerUrl = ref("");
    watch(
      // 監聽route路徑，一有變更就更新麵包屑
      () => route.path,
      () => {
        if (route.params.countryId && route.params.countryId !== "00") {
          const countryId = route.params.countryId;
          apiCountries({
            countryId,
            expertAdvicePage: 0,
            contributorPage: 0,
          }).then((res) => {
            bannerUrl.value = res.data.countryFile;
          });
          // .catch(() => {});
        } else {
          bannerUrl.value = "";
        }
      }
    );
    return { bannerUrl };
  },
};
</script>

<style lang="scss" scoped></style>
